import { useCallback, useState } from "react";

// material ui
import Box from "@mui/material/Box";

// styles
import styles from "./styles.module.css";

// components
import First from "./steps/first";
import Second from "./steps/second";
import Third from "./steps/third";
import Fourth from "./steps/fourth";
import OnBoardingStepper from "./onBoardingStepper";
import classNames from "classnames";

export enum OnboardingType {
  LARGE = "LARGE",
  SMALL = "SMALL",
}

interface Props {
  type?: OnboardingType;
}

const Onboarding: React.FC<Props> = ({
  type = OnboardingType.LARGE,
}: Props) => {
  const [page, setPage] = useState(1);

  const PageDisplay = useCallback(() => {
    switch (page) {
      case 1:
        return <First type={type} />;
      case 2:
        return <Second type={type} />;
      case 3:
        return <Third type={type} />;
      case 4:
        return <Fourth type={type} />;
      default:
        return <Fourth type={type} />;
    }
  }, [page, type]);

  const onNext = () => {
    if (page === 4) {
      setPage(1);
    } else {
      setPage((currentPage) => currentPage + 1);
    }
  };
  const onPrev = () => {
    if (page === 1) {
      setPage(4);
    } else {
      setPage((currentPage) => currentPage - 1);
    }
  };

  return (
    <Box
      className={classNames(
        type === OnboardingType.SMALL
          ? styles.smaller_outer_container
          : styles.outter_container
      )}>
      {PageDisplay()}
      <OnBoardingStepper
        steps={4}
        activeStep={page}
        onNext={onNext}
        onPrev={onPrev}
      />
    </Box>
  );
};

export default Onboarding;
